// Full-document render of the tempurpedic MattressMatchPage: PageSkeleton (the
// React document shell) wrapping the MattressMatch quiz SPA (normal site
// chrome).
//
// Load-bearing: inside a hydrateRoot(document)-managed tree, an independent
// createRoot mount must not target React-owned DOM, so the SPA renders here as
// a normal React child instead -- gated behind a mounted flag so the server
// document renders an empty div (the SPA is a redux app with async-loading
// SVGs; it was never server-rendered and hydration must not try). The redux
// store comes from the global ReduxProvider the client entry wraps around the
// hydrated tree.
import React from "react";
import { MattressMatch } from "tsi-common-react/src/apps/mattress-match/MattressMatch/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.MattressMatchPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div>{mounted && <MattressMatch />}</div>
        </PageSkeleton>
    );
};
